function joinRegions(matches) {
  if (matches.length === 0) {
    return []
  }

  return matches.reduce((regions, position, index) => {
    if (index === 0) {
      return [[matches[0], matches[0]]]
    }

    if (position === regions[regions.length - 1][1] + 1) {
      const region = regions.pop()
      region[1] = position
      regions.push(region)
    } else {
      regions.push([position, position])
    }

    return regions
  }, [])
}

function getMatchesReduce(original, search) {
  return search.split('').reduce((matches, character) => {
    const position = matches.length === 0 ? -1 : matches[matches.length - 1]
    const newPosition = original.substring(position + 1).indexOf(character)

    if (newPosition < 0) {
      return matches
    }

    return [
      ...matches,
      position === -1 ? newPosition : position + 1 + newPosition,
    ]
  }, [])
}

function matchedRegions(text, search) {
  const matches = getMatchesReduce(text.toLowerCase(), search.toLowerCase())

  return joinRegions(matches)
}

export { matchedRegions }
